import Collapse from '@material-ui/core/Collapse';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from '../../assets/jss/sideNavigationStyle';
import { hideOtherSubMenu, manageIcon } from '../../helper/NavigationMenu';

class ShortMenuBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CLIENT: false,
      PROJECT: false,
      SETTINGS: false,
      USER: false,
      VULNERABILITY: false,
      REMEDIATION: false,
      activeTab: '',
    };
  }

  componentDidMount() {
    const { activeTab } = this.state;
    const { defaultSelectedMenu } = this.props;

    if (!activeTab && defaultSelectedMenu) {
      this.checkActiveMenu(defaultSelectedMenu);
    }
  }

  /*
     * function to sets the current state of a menu item
     * i.e whether it is in expanded or collapsed or a collapsed state
     * */
  handleClick(item) {
    const { state } = this;
    const newState = hideOtherSubMenu(item, state[item]);
    this.setState(newState);
  }

  /**
   * function to check and update for current active menu
   * @param item
   */
  checkActiveMenu = (item) => {
    const { onMenuSelect } = this.props;

    onMenuSelect(item);
    this.setState({
      activeTab: item,
    });
  };

  CListItem = (subOption, classes) => {
    const { activeTab } = this.state;
    return (
      <ListItem
        className={`${classes.menuColors}  ${subOption.isSubMenu ? classes.subMenuList : ''} ${(activeTab === subOption.module) ? classes.activeMenu : ''} `}
        button
        selected={activeTab === subOption.module}
        key={subOption.title}
      >
        {manageIcon(subOption.icon)}
        {subOption.isSubMenu ? (
          <ListItemText inset onClick={() => this.handleClick(subOption.id)}>
            <Trans i18nKey={subOption.title} />
          </ListItemText>
        ) : (
          ''
        )}
      </ListItem>
    );
  };

  /*
     * function to handle menu , if the menu item doesn't have any child,
     * this method simply returns a clickable menu item that redirects to any location
     * and if there is no child this method uses recursion to go until the last level of
     * children and then returns the item by the first condition.
     * */
  shortMenuHandler(children) {
    const {
      classes,
      menuList,
    } = this.props;

    const { state, activeTab } = this;

    if (children) {
      return children.map((subOption) => {
        if (menuList.indexOf(subOption.module) > -1) {
          if (!subOption.children) {
            return (
              <div aria-hidden="true" key={subOption.title} onClick={() => this.checkActiveMenu(subOption.module)}>
                <Link to={subOption.path} className={classes.links}>
                  {!subOption.isSubMenu ? (
                    <Tooltip title={<Trans i18nKey={subOption.title} />} placement="right">
                      {this.CListItem(subOption, classes)}
                    </Tooltip>
                  )
                    : this.CListItem(subOption, classes)}
                </Link>
              </div>
            );
          }
          return (
            <div
              aria-hidden="true"
              key={subOption.title}
              className={classes.sidebarParentMenu}
              onClick={() => this.checkActiveMenu(subOption.module)}
            >
              <Tooltip title={<Trans i18nKey={subOption.title} />} placement="right">
                <ListItem
                  className={`${classes.menuColor}  ${(activeTab === subOption.module) ? classes.activeMenu : ''} `}
                  button
                  selected={activeTab === subOption.module}
                  onClick={() => this.handleClick(subOption.title)}
                >
                  {manageIcon(subOption.icon)}
                  {state[subOption.title] ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
              </Tooltip>
              <Collapse
                className={classes.sidebarUlUl}
                in={state[subOption.title]}
                timeout="auto"
                unmountOnExit
              >
                {this.shortMenuHandler(subOption.children)}
              </Collapse>
            </div>
          );
        }
        return '';
      });
    }
  }

  render() {
    const { classes, menuItems } = this.props;

    return (
      <div className={classes.list}>
        <Drawer variant="persistent" anchor="left" open classes={{ paper: classes.list }}>
          <div>
            <List>{this.shortMenuHandler(menuItems)}</List>
          </div>
        </Drawer>
      </div>
    );
  }
}

const stylesheets = withStyles(styles, { withTheme: true })(ShortMenuBar);
export default withTranslation()(stylesheets);
